/**
 * Default fallback count when total inventory count is not available
 */
export const DEFAULT_VEHICLE_COUNT = 9000

/**
 * Generate default AI search placeholders with dynamic vehicle count
 * @param totalCount - Total inventory count (optional, defaults to DEFAULT_VEHICLE_COUNT)
 */
export const getDefaultSearchPlaceholders = (totalCount?: number): string[] => {
  const count = totalCount ?? DEFAULT_VEHICLE_COUNT
  const formattedCount = count.toLocaleString('en-GB')

  return [
    `Search ${formattedCount}${totalCount ? '' : '+'} used cars`,
    'An EV for long distances',
    'What can I get for £350?',
    'I need heated seats',
    'Must have Android Auto',
  ]
}

/**
 * Static default placeholders
 */
export const DEFAULT_SEARCH_PLACEHOLDERS: string[] =
  getDefaultSearchPlaceholders()
